import { getCurrentUserHook, useProduct } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import React from 'react';

const withLaunchDarkly = (Component) => {
  return function WithStripeElements(props) {
    const currentUser = getCurrentUserHook();
    const productType = useProduct();
    const LDConfig = {
      clientSideID: envConfig.launchDarklyClientID,
      context: {
        kind: 'user',
        key: currentUser?.customerId || 'default-key',
        plan: currentUser?.chargeBeePlanId || 'default-plan',
        domain: currentUser?.domain || 'default-domain',
        subscriptionStatus: currentUser?.subscriptionStatus || 'inactive',
        productType: productType || 'MSP'
      },
      reactOptions: {
        sendEventsOnFlagRead: false
      }
    };

    // Wrap the component with the LaunchDarkly provider
    const LDWrappedComponent = withLDProvider(LDConfig)(Component);

    return <LDWrappedComponent {...props} />;
  };
};

export default withLaunchDarkly;
